import { useState } from 'react';
import { Button, Stack } from 'react-bootstrap';
import { usePhanHeBaoHiemYTeContext } from '../../contexts/PhanHeBaoHiemYTeContext';
import XmlPreview from '../xml-preview';
import PatientRow from './PatientRow';
import { XMLTabContextProvider } from '../../contexts';

type Props = {
	showAction?: boolean;
}

const PrimaryInfo = ({ showAction = true }: Props) => {
	const { patientInfo } = usePhanHeBaoHiemYTeContext();
	const [shouldOpenXmlPreview, setShouldOpenXmlPreview] = useState<boolean>(false);

	return (
		<div>
			<Stack
				direction="horizontal"
				className="d-flex align-items-center justify-content-between spaces border py-4 pr-4 flex-wrap"
			>
				<div className="d-flex">
					<h4 className="text-title fw-bold fs-4 spaces mb-1 py-5 px-10">
						Thông tin bệnh nhân
					</h4>

					{patientInfo?.id && showAction && (
						<Stack direction="horizontal" className="spaces pl-8 gap-8">
							<Button
								className="btn-fill min-w-60px"
								onClick={() => setShouldOpenXmlPreview(true)}
							>
								XML
							</Button>
						</Stack>
					)}
				</div>

				<PatientRow patientInfo={patientInfo} className="ms-auto" />
			</Stack>

			<XMLTabContextProvider>
				{shouldOpenXmlPreview && (
					<XmlPreview handleClose={() => setShouldOpenXmlPreview(false)} />
				)}
			</XMLTabContextProvider>
		</div>
	);
};

export default PrimaryInfo;
